export default "__VITE_ASSET__1lUTxf6n__"